module.exports = __webpack_public_path__ + "img/CUSTOMER_1.97d607d6.png";